"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.archiveThread = archiveThread;
exports.autoTitle = autoTitle;
exports.createThread = createThread;
exports.deleteThread = deleteThread;
exports.loadThreads = loadThreads;
exports.upsertThread = upsertThread;
var _constants = require("./constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const STORAGE_KEY_PREFIX = 'eimp_smartassist_active_thread';
function getStorageKey(eid) {
  const normalized = eid == null ? '' : String(eid).trim();
  if (!normalized) return null;
  return "".concat(STORAGE_KEY_PREFIX, ":").concat(normalized);
}
function loadThreads(eid) {
  try {
    const key = getStorageKey(eid);
    if (!key) return [];
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const thread = JSON.parse(raw);
    return thread ? [thread] : [];
  } catch (_unused) {
    return [];
  }
}
function upsertThread(thread) {
  try {
    var _thread$context;
    const key = getStorageKey(thread === null || thread === void 0 || (_thread$context = thread.context) === null || _thread$context === void 0 ? void 0 : _thread$context.eid);
    if (!key) return thread;
    const updated = _objectSpread(_objectSpread({}, thread), {}, {
      updatedAt: new Date().toISOString()
    });
    localStorage.setItem(key, JSON.stringify(updated));
    return updated;
  } catch (_unused2) {
    return thread;
  }
}
function createThread() {
  let {
    featureType,
    context = {}
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const now = new Date().toISOString();
  return {
    id: "thread_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 8)),
    backendThreadId: null,
    title: '',
    featureType: featureType || null,
    createdAt: now,
    updatedAt: now,
    context,
    messages: [],
    status: _constants.THREAD_STATUS.ACTIVE
  };
}
function deleteThread(threadId) {
  try {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith("".concat(STORAGE_KEY_PREFIX, ":"))) continue;
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const thread = JSON.parse(raw);
      if (thread && thread.id === threadId) {
        localStorage.removeItem(key);
      }
    }
  } catch (_unused3) {}
}
function archiveThread(_threadId) {}
function autoTitle(thread) {
  if (thread.title) return thread.title;
  const first = thread.messages.find(m => m.role === 'user');
  if (!first) return 'New conversation';
  const txt = first.text || '';
  return txt.length > 60 ? txt.slice(0, 57) + '…' : txt || 'New conversation';
}